import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'
import findIndex from 'lodash/findIndex'

import { ExpandableBlocks, ContentBlock, ExpandableContext } from 'components/ContentBlock'
import { Form, Text, Number as NumberInput } from 'components/forms'
import { notEmpty } from 'helpers/validators'
import Button from 'components/Button'
import Divider from 'components/Divider'
import globalStyles from 'style/app.module.scss'

const fieldsByBlocks = [
	['acountNum', 'name'],
	['discount'],
	['accountingReduced', 'accountingNormal', 'accountingZeroPercent', 'accountingSpecial']
]

const SalesGroup = ({ data = {}, formData, mutations: { updateItem, createItem }, newRecord }) => {
	const [t] = useTranslation()
	const getDiscountFields = vals => {
		const baseLabel = t('options_section.fields.discount')
		const fields = new Array(20).fill(null).map((_, i) => (
			<NumberInput
				key={i}
				field={`discount[${i}]`}
				label={(i !== 0 && i % 4) ? '' : `${baseLabel} ${i + 1} - ${i + 4}`}
				shrink
				withControls={false}
			/>
		))
		return(
			<Row>
				<Col xs className='narrow-col'>{fields.slice(0, 4)}</Col>
				<Col xs className='narrow-col'>{fields.slice(4, 8)}</Col>
				<Col xs className='narrow-col'>{fields.slice(8, 12)}</Col>
				<Col xs className='narrow-col'>{fields.slice(12, 16)}</Col>
				<Col xs className='narrow-col'>{fields.slice(16)}</Col>
			</Row>
		)
	}
	const handleFailSubmit = setExpandedId => errors => {
		const errorField = Object.keys(errors)[0]
		const expandBlockId = findIndex(fieldsByBlocks, fieldsArr => fieldsArr.find(field => field === errorField))
		// First ContentBlock is always expanded
		if(expandBlockId > 0) {
			setExpandedId(expandBlockId.toString())
		}
	}

	return(
		<ExpandableBlocks>
			<ExpandableContext.Consumer>
				{({ setExpandedId }) => (
					<Form
						initialValues={formData}
						onSubmit={newRecord ? createItem : updateItem}
						smartSubmit={!newRecord}
						onSubmitFailure={handleFailSubmit(setExpandedId)}
						className={globalStyles['flex-cols']}
					>
						{({ formState: { values } }) => (
							<Fragment>
								<ContentBlock alwaysExpanded>
									<Row>
										<Col xs className='narrow-col'>
											<Text
												field='acountNum'
												label={t('options_section.fields.acountNum')}
												{...notEmpty()}
												validateOnChange
												shrink
											/>
										</Col>
										<Col xs>
											<Text
												field='name'
												label={t('options_section.fields.name')}
												{...notEmpty()}
												validateOnChange
											/>
										</Col>
									</Row>
								</ContentBlock>
								<ContentBlock label={t('options_section.strings.loyalty_discount')} blockId={'1'} startExpanded>
									{getDiscountFields()}
								</ContentBlock>
								<ContentBlock label={t('options_section.strings.accounting')} blockId={'2'}>
									<Row>
										<Col xs className='narrow-col'>
											<Text
												field='accountingReduced'
												label={t('options_section.fields.accountingReduced')}
												shrink
											/>
										</Col>
										<Col xs className='narrow-col'>
											<Text
												field='accountingNormal'
												label={t('options_section.fields.accountingNormal')}
												shrink
											/>
										</Col>
										<Col xs className='narrow-col'>
											<Text
												field='accountingZeroPercent'
												label={t('options_section.fields.accountingZeroPercent')}
												shrink
											/>
										</Col>
										<Col xs className='narrow-col'>
											<Text
												field='accountingSpecial'
												label={t('options_section.fields.accountingSpecial')}
												shrink
											/>
										</Col>
									</Row>
								</ContentBlock>
								{newRecord &&
									<Fragment>
										<Divider />
										<div>
											<Button
												type='submit'
												status={(values.acountNum || values.name) ? 'primary' : 'inactive'}
												text={t('common.buttons.create')}
											/>
										</div>
									</Fragment>
								}
							</Fragment>
						)}
					</Form>
				)}
			</ExpandableContext.Consumer>
		</ExpandableBlocks>
	)
}

export default SalesGroup
